var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("SalaryEdit", {
            attrs: { inline: false },
            on: { input: _vm.emitChangeEvent },
            scopedSlots: _vm._u([
              {
                key: "input-info",
                fn: function() {
                  return [
                    _c("div", [
                      _vm._v("Dein Mindestgehalt - pro Monat - "),
                      _c("b", [_vm._v("Brutto")]),
                      _vm._v(" vor Abzug der Steuern.")
                    ]),
                    _vm._v(" "),
                    _vm.isPartTime
                      ? _c("div", [
                          _vm._v(
                            "Bei Teilzeit bitte auf Basis von Vollzeit eingeben - das ist wichtig für\n\t\t\t\t\tdas Matching.\n\t\t\t\t"
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("Jobs mit höherem Gehalt werden angezeigt!")
                    ])
                  ]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.salary,
              callback: function($$v) {
                _vm.salary = $$v
              },
              expression: "salary"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("JonInfo", {
        scopedSlots: _vm._u([
          {
            key: "message",
            fn: function() {
              return [
                _vm._v(
                  "\n\t\t\tDeine genaue Gehaltsangabe wird ArbeitgeberInnen nicht angezeigt, sondern dient nur dem Matching bzw.\n\t\t\tdem Ermitteln, ob ein Job passt.\n\t\t"
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }